import { useMutation } from '@apollo/client'
import { DeleteDefaultPrice, DeleteDefaultPriceVariables } from '../../types'
import { DELETE_DEFAULT_PRICE } from './operations'

interface Props {
  onCompleted?: () => void
}

export const useDeleteDefaultPrice = ({ onCompleted }: Props) =>
  useMutation<DeleteDefaultPrice, DeleteDefaultPriceVariables>(DELETE_DEFAULT_PRICE, {
    onCompleted,
  })
